import { store } from "Store/store.index";
import {
    USER_SIGN_IN_SUCCESS,
    GOT_USER_SUBSCRIPTION,
} from '../constants';
import {
    SDK_FINISH_LOAD,
} from 'Constants/app.constant';
import {
    CONVERT_HTML_TO_PDF, 
    CONVERT_COMBINE_FILES,
} from 'Components/viewer/ui/constants/convert.constants';
import {
    OPEN_FILE_LOCAL,
} from 'Components/viewer/ui/constants/openfile.constants';
import { fileController } from 'Components/viewer/Controllers/index';
import { queryVariable } from "@/utils/utils";
import { convertApis } from "Api/index";
import { TASK_STATUS } from "Api/constants";

class ChromeExtensionService {
    constructor () {
        this.action = queryVariable('action');
        this.docId = queryVariable('docId');
        this.origin = queryVariable('origin');
        this.docName = queryVariable('docName');
        this.link = queryVariable('link');
        this.hasSign = false;
        this.hasSdkLoad = false;
        this.hasSubscribe = false;
        this.hasDoAction = false;
        this.addEventListener();
    }
    _initStore () {
        return new Promise((resolve) => {
            let flag = setInterval(() => {
                if (store) {
                    clearInterval(flag);
                    resolve();
                }
            }, 0);
        });
    }
    async addEventListener () {
        await this._initStore().catch((error) => {
            console.error(error);
        });
        store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, () => {
            this.hasSign = true;
            if (store.appStore.isOnPremiseDeployMode) {
                this.hasSubscribe = true;
            }
            this.doAction();
        });
        store.appStore.addAppEventListener(SDK_FINISH_LOAD, () => {
            this.hasSdkLoad = true;
            this.doAction();
        });
        store.appStore.addAppEventListener(GOT_USER_SUBSCRIPTION, () => {
            this.hasSubscribe = true;
            this.doAction();
        });
    }

    doAction () {
        if (!this.hasSign || !this.hasSdkLoad || !this.hasSubscribe || this.hasDoAction) return ;
        const { action, docId, origin, docName } = this;
        if (origin !== 'chromeExtension') return ;
        this.hasDoAction = true;
        const PDFUI = store.viewer.pdfui;
        const prevName = docName && docName.substring(0, docName.lastIndexOf('.'));
        switch (action) {
            case 'pdfToJPG': 
                this.doConvert(docId, 6, undefined, `${prevName}.zip`);
                break;
            case 'pdfToWord': 
                this.doConvert(docId, 11, {
                    is_include_images: true,
                    layout_settings: 'retain_flowing_text'
                }, `${prevName}.docx`);
                break;
            case 'pdfToExcel': 
                this.doConvert(docId, 14, {
                    is_auto_detect: true,
                    decimal_symbol: 'comma',
                    thousands_separator: 'period',
                    excel_sheet_type: 'all_table'
                }, `${prevName}.xlsx`);
                break;
            case 'pdfToPPT': 
                this.doConvert(docId, 22, {
                    is_include_comments: true
                }, `${prevName}.pptx`);
                break;
            case 'convertToPDF': 
                // convertToPDF 比较特殊，非公用组件，改造比较麻烦，故使用dom查找方式
                const $toolsBtn = document.querySelector('.get-start-guid-wrapper .ant-tabs > .ant-tabs-nav .ant-tabs-tab:nth-of-type(2)');
                if ($toolsBtn) {
                    $toolsBtn.click();
                    setTimeout(() => {
                        const $convertToPDFBtn = document.querySelector('.get-start-guid-wrapper .feature-container .convert-to-pdf-wrapper .hover-btn');
                        $convertToPDFBtn && $convertToPDFBtn.click();
                    }, 100);
                }
                break;
            case 'signAPDF': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('foxit-eSign');
                });
                break;
            case 'webPageToPDF': 
                let link = this.link || '';
                if (!link.startsWith('http')) {
                    link = '';
                }
                !store.appStore.isDisableButton(CONVERT_HTML_TO_PDF) && 
                store.appStore.emitEvent('actionConvert', { action: CONVERT_HTML_TO_PDF, args: link });
                break;
            case 'combineFiles': 
                !store.appStore.isDisableButton(CONVERT_COMBINE_FILES) && 
                store.appStore.emitEvent('actionConvert', { action: CONVERT_COMBINE_FILES });
                break;
            case 'compressPDF': 
                !store.appStore.isDisableButton('file-tab-pdf-reduce-size') && 
                this.openFileByDocId(docId, docName).then(() => {
                    PDFUI.getComponentByName('convert-tab').then(component => {
                        component && component.active();
                        PDFUI.customs.showReduceFileSizeDialog();
                    });
                });
                break;
            case 'editTextObject': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('edit-tab', 'edit-text');
                });
                break;
            case 'searchReplace': 
                this.openFileByDocId(docId, docName).then(() => {
                    PDFUI.getComponentByName('edit-tab').then(component => {
                        component && component.active();
                        setTimeout(() => {
                            PDFUI.eventEmitter.emit('active-find-replace');
                        }, 1500);
                    });
                });
                break;
            case 'insertPages': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('organize-tab', 'insert-pages-button');
                });
                break;
            case 'rotatePages': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('organize-tab', 'file-tab-page-rotate-left');
                });
                break;
            case 'splitPages': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('organize-tab', 'split-document-button');
                });
                break;
            case 'deletePages': 
                this.openFileByDocId(docId, docName).then(() => {
                    PDFUI.getCurrentPDFDoc().then(pdfDoc => {
                        const pageCount = pdfDoc.getPageCount();
                        if (pageCount > 1) {
                            this.requestBtnOperation('organize-tab', 'delete-pages-button');
                        }
                    });
                });
                break;
            case 'requestSignature': 
                this.openFileByDocId(docId, docName).then(() => {
                    this.requestBtnOperation('foxit-eSign', 'request-signature');
                });
                break;
        }
    }
    doConvert (docId, type, confText, fileName) {
        if (store.appStore.isDisableButton(CONVERT_HTML_TO_PDF)) return ;
        if (!docId) {
            return this.showOpenFileDlg();
        }
        const data = [{ docid: docId }];
        store.taskStore.setHasTask(true);
        store.taskStore.onUpdateTaskMessage({ status: TASK_STATUS.CONVERT, progress: 0 });
        return convertApis.doConvert(data, type, {
            confText: JSON.stringify(confText)
        }).then(res => {
            return new Promise((resolve, reject) => {
                const taskId = res && res.data && res.data.taskid;
                if (taskId === undefined) {
                    reject(res);
                } else {
                    let timer;
                    store.taskStore.hasTask = true;
                    store.taskStore.convertTaskId = taskId;
                    convertApis.doMonitorStatus(taskId, res => {
                        if (res.url) {
                            clearTimeout(timer);
                            store.taskStore.onUpdateTaskMessage({ 
                                status: TASK_STATUS.FINISH, 
                                url: res.url, 
                                fileName 
                            });
                        } else if (res.data.errorBody) {
                            clearTimeout(timer);
                            const errorBody = JSON.parse(res.data.errorBody);
                            reject(errorBody.message);
                        } else if (res.msg) {
                            clearTimeout(timer);
                            reject(res.msg);
                        }
                    });
                    timer = setTimeout(() => {
                        store.taskStore.hasTask = false;
                        reject('Interface request timeout error!');
                    }, 30000);
                }
            });
        }).finally(() => {
            store.taskStore.setHasTask(false);
        });
    }
    openFileByDocId (docId, docName) {
        if (store.appStore.isDisableButton(OPEN_FILE_LOCAL)) return ;
        return new Promise((res, rej) => {
            if (!docId) {
                this.showOpenFileDlg();
                const PDFUI = store.viewer.pdfui;
                const listener = PDFUI.addViewerEventListener(UIExtension.PDFViewCtrl.Events.renderFileSuccess, () => {
                    res();
                    listener();
                })
                return ;
            }
            store.userStore.setAllowNoSignIn(true);
            const url = convertApis.doGetDownloadUrl(docId, docName);
            fileController.doOpenFileByUrl(url, docName, error => {
                rej(error);
            }, true, success => {
                res(success);
            });
        }).finally(() => {
            store.userStore.setAllowNoSignIn(false);
        });
    }
    requestBtnOperation (tabName, btnName) {
        const PDFUI = store.viewer.pdfui;
        return PDFUI.getComponentByName(tabName).then(component => {
            if (!component) return ;
            component.active();
            if (!btnName) return ;
            setTimeout(() => {
                PDFUI.getComponentByName(btnName).then(btnComponent => {
                    const dropdown = btnComponent.getDropdown();
                    if (dropdown) {
                        dropdown.active();
                    } else {
                        btnComponent.controller.handle();
                    }
                });
            }, 1500);
        });
    }
    showOpenFileDlg () {
        store.appStore.showOpenFileDlg(false, 'LOCAL_COMPUTER');
    }
}
export default ChromeExtensionService;
